var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v("\n    AUTH\n    "),(_vm.$auth.ready())?_c('span',[_c('p',[_vm._v("check:"+_vm._s(_vm.$auth.check()))]),_c('p',[_vm._v("user:"+_vm._s(_vm.$auth.user()))])]):_vm._e(),(_vm.hasError)?_c('span',[_vm._v("ERROR")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }